import React from 'react';
import { Tooltip } from 'antd';
import { Info } from 'lucide-react';
import { tone } from './tones';

/**
 * KPI card: label, big value, optional hint/trend and a footer slot for breakdowns.
 * Clickable when `onClick` is given.
 */
export default function StatCard({
    label,
    value,
    icon,
    tone: toneName = 'brand',
    valueTone,
    hint,
    help,
    trend,
    footer,
    onClick,
    className = ''
}) {
    const t = tone(toneName);
    const Wrapper = onClick ? 'button' : 'div';
    return (
        <Wrapper
            type={onClick ? 'button' : undefined}
            onClick={onClick}
            className={`stat-card h-full w-full text-left flex flex-col ${onClick ? 'cursor-pointer hover:border-surface-300' : ''} ${className}`}>
            <div className="flex items-start justify-between gap-3">
                <div className="flex items-center gap-1.5 text-[13px] font-medium text-surface-500">
                    {label}
                    {help && (
                        <Tooltip title={help}>
                            <Info className="text-surface-400 text-[13px]" />
                        </Tooltip>
                    )}
                </div>
                {icon && <span className={`flex h-8 w-8 items-center justify-center rounded-lg text-[15px] ${t.chip}`}>{icon}</span>}
            </div>
            <div className="mt-2 flex items-baseline gap-2">
                <span className={`text-[28px] font-semibold tracking-tight tabular-nums leading-none ${valueTone ? tone(valueTone).text : 'text-surface-900'}`}>
                    {value}
                </span>
                {trend && <span className="text-xs font-medium">{trend}</span>}
            </div>
            {hint && <div className="mt-1.5 text-xs text-surface-500">{hint}</div>}
            {footer && <div className="mt-4 pt-3 border-t border-surface-100 text-sm">{footer}</div>}
        </Wrapper>
    );
}
